import * as Yup from 'yup';

// eslint-disable-next-line max-len
import { AdminIntegrationStockLocationExtended } from '~services/admin/integration/stockLocation/types';

export const FIELDS_NAME = {
  NETWORK_NODE_IDS: 'networkNodeIds',
} as const;

export const getDefaultStockLocations = (
  stockLocations: AdminIntegrationStockLocationExtended[],
): AdminIntegrationStockLocationExtended[] =>
  stockLocations.filter((stockLocation) => stockLocation.selected);

export const getDefaultNetworkNodeIds = (
  stockLocations: AdminIntegrationStockLocationExtended[],
): string[] => {
  const defaultStockLocations = getDefaultStockLocations(stockLocations);

  return defaultStockLocations.map(
    (stockLocation) => stockLocation.networkNodeId,
  );
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getInitialValues = (
  stockLocations: AdminIntegrationStockLocationExtended[],
) => ({
  [FIELDS_NAME.NETWORK_NODE_IDS]: getDefaultNetworkNodeIds(stockLocations),
});

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.NETWORK_NODE_IDS]: Yup.array().of(Yup.string()),
});
